// extracted by mini-css-extract-plugin
module.exports = {"banner":"top-banner_banner__Rm0r2","title":"top-banner_title__lRF_F","subtitle":"top-banner_subtitle__OU5eH"};